module.exports = __webpack_public_path__ + "img/蒙版组 1@2x (5).ab788a83.webp";